import {
  Box,
  Button,
  Grid,
  InputAdornment,
  // Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import React, { useContext } from "react";
import { useEffect } from "react";
import User1 from "../services/db/user";
import { useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import objToXlsx from "../utils/objToXlsx";
import htmlToPdf from "../utils/htmlToPdf";
import { useRef } from "react";
import search from "../utils/searchEngine";
import { InfoContext } from "../services/Context/Info/context";
import Search from "@mui/icons-material/Search";
import PropTypes from "prop-types";

const ActionButtons = ({ row }) => {
  const {
    data: { userData },
    setData,
  } = useContext(InfoContext);
  const hBlock = (active) => {
    new User1()
      .updateUser(`${row.phoneNumber}_${row.role}`, { active })
      .then(() => {
        const ind = userData.findIndex(
          (el) => el.phoneNumber === row.phoneNumber && el.role === row.role
        );
        console.log(ind, userData[ind]);
        userData[ind].active = active;
        setData((p) => ({ ...p, userData }));
        alert(
          `User ${!userData[ind].active ? "blocked" : "unblocked"} successfully`
        );
      });
  };
  const commonProps = { size: "small", variant: "contained" };
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        justifyContent: "space-around",
      }}
    >
      <Button {...commonProps} onClick={() => hBlock(false)}>
        Block
      </Button>
      <Button {...commonProps} onClick={() => hBlock(true)}>
        Unblock
      </Button>
    </Box>
  );
};
ActionButtons.propTypes = {
  row: PropTypes.shape({
    phoneNumber: PropTypes.string,
    role: PropTypes.string,
  }),
};
const columns = [
  { field: "displayName", headerName: "Name", width: 160 },
  { field: "email", headerName: "Email", width: 180 },
  { field: "phoneNumber", headerName: "Phone Number", width: 180 },
  { field: "role", headerName: "Role" },
  { field: "address", headerName: "Address", width: 320 },
  {
    field: "amount",
    headerName: "Amount",
    valueGetter: (params) => `₹${params.row.amount || "-"}`,
  },
  {
    field: "action",
    headerName: "Action",
    renderCell: ActionButtons,
  },
];
const User = () => {
  const [searchQuery, setsearchQuery] = useState();
  const pdfRef = useRef();
  const {
    data: { userData },
    setData,
  } = useContext(InfoContext);
  useEffect(() => {
    if (!userData.length)
      new User1().allUsers().then((r) => {
        setData((p) => ({ ...p, userData: r }));
      });
  }, []);

  const getRowSpacing = React.useCallback((params) => {
    return {
      top: params.isFirstVisible ? 0 : 5,
      bottom: params.isLastVisible ? 0 : 5,
    };
  }, []);
  const searchData = search(searchQuery, userData, [
    "displayName",
    "email",
    "address",
  ]);



  console.log("searchData", searchData);
  return (
    <Box display={"flex"} flexDirection="column" width="100%" height="100%">
      <Grid container maxWidth={"lg"} paddingTop={1} paddingLeft={5}>
        {/* First part */}
        <Grid item xs={12}>
          <Typography variant="h5">Users</Typography>
        </Grid>
        {/* Second Part */}
        <Grid
          item
          xs={12}
          container
          paddingY={2}
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
        >
          <Grid xs={2}>
            <Button
              variant="contained"
              size="madium"
              onClick={() => objToXlsx(userData, "user")}
            >
              Excel
            </Button>
          </Grid>
          <Grid item xs={2}>
            <Button
              variant="contained"
              size="madium"
              onClick={() => htmlToPdf(pdfRef.current, "user", "save")}
            >
              PDF
            </Button>
          </Grid>
          <Grid item xs={2}>
            <Button
              variant="contained"
              size="madium"
              onClick={() => htmlToPdf(pdfRef.current, "user", "view")}
            >
              Print
            </Button>
          </Grid>
          <Grid
            item
            xs={6}
            container
            direction="column"
            alignItems="center"
            justifyContent="flex-end"
          >
            <TextField
              variant="outlined"
              size="small"
              label="Search"
              sx={{ width: "80%" }}
              InputProps={{
                endAdornment: (
                  <InputAdornment>
                    <Search />
                  </InputAdornment>
                ),
              }}
              onChange={(e) => setsearchQuery(e.currentTarget.value)}
            />
          </Grid>
        </Grid>
        {/* Third Part tabel data */}
        <Grid item xs={12}>
          <Paper style={{ height: "100%", overflowX: "scroll" }}>
            <DataGrid
              className="datagrid"
              rows={searchData}
              columns={columns}
              getRowClassName={() => "row"}
              showCellVerticalBorder={false}
              getRowId={(row) => `${row.phoneNumber}_${row.role}`}
              ref={pdfRef}
              hideFooterPagination={true}
              getRowSpacing={getRowSpacing}
              rowHeight={80}
            />
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default User;
